const Checkbox = {
  defaultProps: {
    size: 'xs',
  },
}

export default Checkbox
